import { render, staticRenderFns } from "./RegisterFirebase.vue?vue&type=template&id=47ab5894&"
import script from "./RegisterFirebase.vue?vue&type=script&lang=js&"
export * from "./RegisterFirebase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports